import React, { useState } from 'react';
import { PrimaryButton, SecondaryButton } from '@client/new/components/button';
import { Modal } from '@client/new/components/Modal/Modal';
import { LibraryVideo } from '../videos.domain';
import { TextField } from '@client/new/components/basic';

export type ChangeNameModalProps = {
  isOpen: boolean;
  onClose: () => void;
  media: LibraryVideo;
  onSave: (name: string) => void;
};
export function ChangeNameModal(props: ChangeNameModalProps) {
  const [selectedName, setSelectedName] = useState(props.media.name);

  const handleSaveClick = () => {
    props.onSave(selectedName);
    props.onClose();
  };

  return (
    <Modal
      title="Change name"
      height="auto"
      sx={{ maxWidth: 800 }}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <div className="my-4">
        <TextField
          autoFocus
          label="Name"
          value={selectedName}
          onChange={(e) => setSelectedName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSaveClick();
            }
          }}
        />
      </div>
      <div className="flex justify-end">
        <div className="flex gap-4">
          <SecondaryButton
            style={{ backgroundColor: 'white', color: 'black' }}
            onClick={props.onClose}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton onClick={handleSaveClick}> Save </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
}
